import { Box, Divider, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)(() => ({
  width: "100%",
})) as typeof Box;

export const StyledPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(2),
})) as typeof Paper;

export const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2),
})) as typeof Divider;
